<template>
  <div class="operation-verification">
    <main ref="scrollY">
      <transition-group name="transition" tag="ul">
        <div class="verification" v-for="(verification,index) in formValidates" :key="verification.id">
          <div class="title">操作校验{{formValidates.length - index}}<i class="del-verification" @click="delVerification(index)">×</i></div>
          <div class="content">
           <el-form ref="form" class="form" :model="verification" label-position="left" label-width="80px">
             <el-form-item v-if="type==='process'" class="operation-type" label="节点" prop="nodeId" :rules=" {required: true, message: '请输入节点', trigger: 'change'}">
                <el-select v-model="verification.nodeId" placeholder="请选择节点" filterable clearable @change="verification.expression=''">
                  <el-option
                    v-for="item in nodes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="条件" prop="expression" :rules=" {required: true, message: '请输入公式', trigger: 'blur'}">
                <div class="calculate" @click="openCalculate(verification.expression, verification)" v-html="expressionShow(verification.expression)">{{verification.expression}}</div>
              </el-form-item>
              <el-form-item label="提示语" prop="tip" :rules=" {required: true, message: '请输入提示语', trigger: 'blur'}">
              <el-input v-model="verification.tip" placeholder="请输入条件成立时的提示语"></el-input>
              </el-form-item>
              <el-form-item class="prompt-type" label="提示类型" prop="promptType" :rules=" {required: true, message: '请输入提示类型', trigger: 'change'}">
                <el-select v-model="verification.promptType" placeholder="请选择" clearable>
                  <el-option label="提示且不执行" value="withoutExecute"></el-option>
                  <el-option label="选择是否执行" value="isExecute"></el-option>
                  <el-option label="提示后执行" value="withExecute"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="type==='form'" class="operation-type" label="操作类型" prop="operationType" :rules=" {required: true, message: '请输入操作类型', trigger: 'change'}">
                  <el-select v-model="verification.operationType" multiple collapse-tags placeholder="请选择" >
                  <el-option label="新建" value="create"></el-option>
                  <el-option label="修改" value="update"></el-option>
                </el-select>
              </el-form-item>
             <el-form-item label="是否启用">
               <el-tooltip content="此开关用来控制是否开启此校验" placement="top" class="tooltip">
                 <span class="fa fa-question-circle"></span>
               </el-tooltip>
               <el-switch v-model="verification.enable">
               </el-switch>
             </el-form-item>
            </el-form>
          </div>
        </div>
      </transition-group>
    </main>
    <i class="el-icon-plus add-verification" v-if="formValidates.length<=99" @click="addVerification">添加操作校验</i>
  </div>
</template>

<script>
import { dataSourceReport } from './designMixins/mixins'
import { calculateMixin } from '@/components/form/components/mixins'
import CalculationPanel from '@/components/shared/calculation-panel.vue'
import { UUID } from '@/plugins/common'
import {ColumnComponent} from '@/store/form/component'
export default {
  name: 'FormValidate',
  mixins: [ calculateMixin, dataSourceReport ],
  inject: [ 'formService' ],
  props: ['formValidates', 'type', 'processService', 'definition'],
  components: {
    CalculationPanel
  },
  methods: {
    addVerification () {
      this.formValidates.unshift({
        id: UUID.create(),
        // 流程的节点
        nodeId: '',
        // 选择条件
        expression: '',
        // 提示语
        tip: '',
        // 提示类型
        promptType: '',
        // 操作类型
        operationType: [],
        // 是否启用操作校验
        enable: true

      })
      this.$nextTick(() => {
        let scrollY = this.$refs.scrollY
        scrollY.scrollTop = 0
      })
    },
    delVerification (index) {
      this.formValidates.splice(index, 1)
    },
    openCalculate (expression, verification) {
      if (this.type === 'process') {
        if (verification.nodeId) {
          this.calculatePopup(expression, verification)
        } else {
          this.$message.info('请先选择节点')
        }
      } else {
        this.calculatePopup(expression, verification)
      }
    },
    calculatePopup (expression, verification) {
      this.$Popup.calculation({
        parameter: {
          expression: expression,
          dataSource: this.nodeDataSource(verification.nodeId),
          dataSourceEnable: true,
          dataSourceReports: this.formService.options.dataSourceReports
        },
        width: '1000px',
        calculationType: 'java'
      }).then((data) => {
        // action 两种 confirm 表示点击的是确认, cancel 表示取消
        if (data.action === 'confirm') {
          verification.expression = data.value
        }
      })
    },
    expressionShow (expression) {
      if (expression) {
        return this.expressionToWithCode(expression)
      }
    },
    validate () {
      const validArr = []
      this.$refs.form && this.$refs.form.forEach((item) => {
        const result = new Promise((resolve, reject) => {
          item.validate((valid) => {
            if (valid) {
              resolve()
            } else {
              this.$message.info('操作校验必填')
              reject(new Error('操作校验必填'))
            }
          })
        })
        validArr.push(result)
      })
      return validArr
    },
    nodeDataSource (nodeId) {
      if (this.type === 'process') {
        let formIds = []
        let dataSource = []
        // 通过nodeId找到节点以及当前节点前的节点
        let previousNode = this.definition.process.getpreviousNode(nodeId)
        this.nodes.forEach(m => {
          if (previousNode.includes(m.id)) { formIds.push(m.formId) }
        })
        // 遍历全部之前节点的formIs取控件
        formIds && formIds.forEach(m => {
          let columns = []
          let form = this.processService.formService.component.children.find(n => n.id === m)
          form.archivedChildren.filter(m => m instanceof ColumnComponent).forEach(m => {
            columns.push({'id': m.archive.columnId, 'name': m.name, 'dataType': m.archive.dataType})
            if (m.properties.archived &&
              m.properties.archived.hasOwnProperty('showColumnId') &&
              m.properties.archived.showColumnId !== '') {
              columns.push({'id': m.properties.archived.showColumnId, 'name': `${m.name}内容`, 'dataType': m.archive.dataType})
            }
          })
          dataSource.push({'id': form.id, 'name': form.name, columns: columns, 'type': 'OneToOne'})
        })
        return dataSource
      } else {
        return this.getDataSource
      }
    }
  },
  computed: {
    nodes () {
      let nodes = []
      this.processService.processDefinition.process.nodes.filter(n => n.type === 'userTask').forEach(m => {
        nodes.push({'formId': m.formId, 'name': m.name, 'id': m.id})
      })
      return nodes
    }
  }
}
</script>

<style lang="scss">
  .operation-verification {
    main {
      max-height: 400px;
      overflow-y: auto;
      .verification {
        margin-bottom: 10px;
        border: solid 1px #DBDBDB;
        border-radius: 4px;
        overflow: hidden;
        &:hover {
          border: solid 1px #91CBF9;
        }
        .title {
          height: 31px;
          line-height: 31px;
          background-color: var(--light-9, #EBF5FF);
          padding-left: 10px;
          color: #232323;
          position: relative;
          .del-verification {
           position: absolute;
           font-size: 20px;
           color: #C2C3C4;
           right: 8px;
           top: 0px;
           cursor: pointer;
           &:hover {
            color: #FF2828;
           }
          }
        }

        .content {
          padding: 10px;
          .calculate {
            width: 100%;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            height: 28px;
            padding-left: 15px;
            background: rgb(235,235,235);
            overflow-y: auto;
          }
          .prompt-type,.operation-type {
            .el-select {
              width: 100%;
            }
          }

          .el-form {
            .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
              display: none;
            }
            .tooltip {
              color: #c9c0c0;
              margin-left: 0;
              margin-right: 16px;

              &:hover {
                color: #409EFF;
              }
            }
          }
        }
      }
    }

    .add-verification {
      display: block;
      width: 103px;
      color: #54ABF1;
      cursor: pointer;
      margin:0 auto;
      margin-top: 10px;
      &:active{
        color: #388DD2
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/operation-verification.vue